import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

const bootstrap = () => platformBrowserDynamic().bootstrapModule(AppModule);

if (module['hot']) {
  bootstrap().catch((err) => console.log(err));
} else {
  document.addEventListener('DOMContentLoaded', () => {
    bootstrap().catch((err) => console.log(err));
  });
}
